import {
  CREATE,
  CLEAR,
  GET,
  UPDATE,
  DELETE,
  SEND,
  CANCEL,
  DELETE_ASSIGNMENT,
  DOWNLOAD,
  CONFIRM_DELIVERY_FOR_SUBMIT,
  CONFIRM_DELIVERY,
  CAN_UPDATE,
  CAN_REMOVE_SERVICE_REQUEST
} from '@hobs/constants/orders';
import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { actionCreator } from './utils/utils';

export const getOrder = orderId => actionCreator(`Orders/${orderId}`, GET);

export const clearOrder = () => {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
};

export const createOrder = body =>
  actionCreator('Orders', CREATE, { method: 'POST', body });

export const updateOrder = (orderId, body) =>
  actionCreator(`Orders/${orderId}`, UPDATE, { method: 'PUT', body });

export const deleteOrder = orderId =>
  actionCreator(`Orders/${orderId}`, DELETE, { method: 'DELETE' });

export const sendOrder = (orderId, body) =>
  actionCreator(`Orders/${orderId}/Send`, SEND, { method: 'POST', body });

export const updateAndSend = (orderId, body) =>
  actionCreator(`Orders/${orderId}/UpdateAndSend`, SEND, {
    method: 'PUT',
    body
  });

export const cancelOrder = (orderId, body) =>
  actionCreator(`Orders/${orderId}/Cancel`, CANCEL, { method: 'POST', body });

export const confirmDeliveryForSubmit = body =>
  actionCreator(
    'Orders/ConfirmDelivery/ForSubmit',
    CONFIRM_DELIVERY_FOR_SUBMIT,
    { method: 'POST', body }
  );

export const confirmDelivery = body =>
  actionCreator('Orders/ConfirmDelivery', CONFIRM_DELIVERY, {
    method: 'PUT',
    body
  });

export const canUpdate = orderId =>
  actionCreator(`Orders/${orderId}/CanUpdate`, CAN_UPDATE, {
    method: 'PUT'
  });

export const deleteOrderAssignment = (orderId, assignmentId) =>
  actionCreator(
    `Orders/${orderId}/Assignments/${assignmentId}`,
    DELETE_ASSIGNMENT,
    { method: 'DELETE' }
  );

export const downloadOrder = orderId => {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`Orders/${orderId}/DownloadExcel`, {
      method: 'GET',
      forceBlob: true
    })
      .then(response => {
        dispatch(success());
        return response;
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: DOWNLOAD.REQUEST };
  }
  function success(response) {
    return { type: DOWNLOAD.SUCCESS, response };
  }
  function failure(error) {
    return { type: DOWNLOAD.FAILURE, error };
  }
};

export const canRemoveServiceRequest = (serviceRequestId) =>
  actionCreator(`Orders/CanRemoveServiceAsync/${serviceRequestId}`, CAN_REMOVE_SERVICE_REQUEST, {
    method: 'GET'
  });

